import { api } from '@/lib/api';
import type { IApiResponse, IJiraIssueRow } from '@skystone/shared';

export const jiraIssuesApi = {
  getAll: async (): Promise<IJiraIssueRow[]> => {
    const result = await api.get<IApiResponse<IJiraIssueRow[]>>('/admin/tbl/jira-issues');
    return result.data;
  },
};
